import type { ITargetingKeyStore } from './types';

/**
 * Returns the stored targeting key, creating a random one on first use.
 * It identifies a browser rather than a person, so it must never be derived from user or account data.
 *
 * The key has to stay stable across loads:
 * - Datadog rejects an empty targeting key.
 * - The provider caches assignments in IndexedDB under md5(context) and never evicts them, so a per-load key orphans one record per load and leaves the offline fallback unreachable.
 * - Percentage rollouts re-roll whenever it changes.
 */
export function resolveTargetingKey(store: ITargetingKeyStore): string {
  const existing = store.get();
  if (existing) {
    return existing;
  }

  const created = crypto.randomUUID();
  store.set(created);
  return created;
}
